// AI Generated Test
import { Component, forwardRef, Input, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'form-field-textarea',
    templateUrl: './form-field-textarea.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldTextareaComponent),
            multi: true,
        },
    ],
})
export class FormFieldTextareaComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    @Input() ngRequired: boolean = false;
    @Input() label: string = '';
    @Input() helpTxt: string = '';
    @Input() placeholder: string = '';
    @Input() rows: string = '';
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;

    @ViewChild('formGroupRef', { static: true }) formGroupRef!: ElementRef;

    private _value: any = '';
    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _isTouched = false;

    constructor (private elementRef: ElementRef) {}

    ngOnInit (): void {
        this.ngRequired = this.ngRequired || false;
    }

    ngAfterViewInit (): void {
        // Initialize validation state after view is ready
        this.updateValidationClasses();
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            this._value = val;
            this._onChange(val);
            this._onTouched();
        }
    }

    writeValue (value: any): void {
        if (value !== undefined && value !== null) {
            this._value = value;
            this._onChange(value);
        }
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onTextareaChange (event: Event): void {
        const target = event.target as HTMLTextAreaElement;
        this.value = target.value;
        this.updateValidationClasses();
    }

    onTextareaKeyup (event: KeyboardEvent): void {
        const target = event.target as HTMLTextAreaElement;
        this.value = target.value;
        this.updateValidationClasses();
    }

    onTextareaBlur (): void {
        this._isTouched = true;
        this._onTouched();
        this.updateValidationClasses();
    }

    isFieldValid (): boolean {
        if (this.ngRequired && (!this._value || this._value === '')) {
            return false;
        }

        return true;
    }

    public updateValidationClasses (): void {
        if (!this.formGroupRef) {
            return;
        }

        const formGroupElement = this.formGroupRef.nativeElement;
        const isValid = this.isFieldValid();

        if (!isValid && this._isTouched) {
            this.setHasError(formGroupElement);
        } else {
            this.removeHasError(formGroupElement);
        }
    }

    private setHasError (formGroupElement: HTMLElement): void {
        if (!formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.add('has-error');
        }
    }

    private removeHasError (formGroupElement: HTMLElement): void {
        if (formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.remove('has-error');
        }
    }
}
